const actions = {
  // Fetching permissions
  FETCH_PERMISSIONS: 'Permissions/FETCH_PERMISSIONS',
  FETCH_PERMISSIONS_RECEIVED: 'Permissions/FETCH_PERMISSIONS_RECEIVED',
  
  // Get single permission
  FETCH_PERMISSION: 'Permissions/FETCH_PERMISSION',
  FETCH_PERMISSION_RECEIVED: 'Permissions/FETCH_PERMISSION_RECEIVED',
  
  // UI state
  REQUESTING: 'Permissions/REQUESTING',
  RESPONSE_ERROR: 'Permissions/RESPONSE_ERROR',
}

export default actions
